// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/var/lib/jenkins/sit-workspace/workspace/prod-mxc-english-crm/src/models/course';
import model_2 from '/var/lib/jenkins/sit-workspace/workspace/prod-mxc-english-crm/src/models/dictionary';
import model_3 from '/var/lib/jenkins/sit-workspace/workspace/prod-mxc-english-crm/src/models/global';
import model_4 from '/var/lib/jenkins/sit-workspace/workspace/prod-mxc-english-crm/src/models/login';
import model_5 from '/var/lib/jenkins/sit-workspace/workspace/prod-mxc-english-crm/src/models/schedule';

export const models = {
model_1: { namespace: 'course', model: model_1 },
model_2: { namespace: 'dictionary', model: model_2 },
model_3: { namespace: 'global', model: model_3 },
model_4: { namespace: 'login', model: model_4 },
model_5: { namespace: 'schedule', model: model_5 },
} as const
